import React from "react";

const TimeProgress = ({ lifeProgress }) => (
  <>
    <div className="w-full bg-black rounded-full border-2 border-white h-10 mt-28 mb-32 relative">
      <div
        className="bg-white h-10 rounded-full flex items-center px-4 transition-all duration-500 ease-in-out"
        style={{ width: `${lifeProgress}%` }}
      >
        <p className="font-bold text-xl md:text-2xl text-black">
          Time is Fading... Day by Day
        </p>
      </div>

      {/* Display Remaining Percentage */}
      <p
        className={`absolute top-2 font-bold text-sm md:text-lg text-white ${
          lifeProgress < 15 ? "text-left left-2" : "text-right right-4"
        }`}
        style={{ left: lifeProgress < 15 ? `${lifeProgress}%` : "auto" }}
      >
        Passed: {lifeProgress.toFixed(2)}%
      </p>
    </div>

    {/* Life Progress Below the Bar */}
    <p className="text-center font-semibold text-white text-lg md:text-2xl">
      {/* Life Progress: {lifeProgress.toFixed(2)}% */}
    </p>
  </>
);

export default TimeProgress;
